export default "immagini/logo_BW.png"